<template>
    <div class="Filters">
        <DropdownWithTrigger>
            <template #trigger>
                <div class="Filters__trigger">
                    <span class="Filters__text hide-mobile">Фильтры</span>
                    <FilterIcon/>
                </div>
            </template>
            <template #dropdown>
                <div class="Filters__dropdown">
                    <FilterGroup
                            v-for="({title, list, singleSelect}, type) of filters"
                            :filter-list="list"
                            :title="title"
                            :filter-type="type"
                            :single-select="singleSelect"
                            :key="type"
                            @select="onSelect(value)"
                    />
                </div>
            </template>
        </DropdownWithTrigger>
    </div>
</template>

<script>
import DropdownWithTrigger from "@/components/DropdownWithTrigger";
import FilterIcon from "@/assets/image/icons/filters.svg?inline";
import FilterGroup from "@/components/FilterGroup";

export default {
    name: "Filters",
    components: {
        DropdownWithTrigger,
        FilterIcon,
        FilterGroup,
    },
    data(){
        return {
            filters: {
                type: this.$store.state.type, /*{
                    title: 'Тип объекта',
                    list: [
                        {
                            title: 'Квартира',
                            value: 'town_flats',
                        },
                        {
                            title: 'Дом',
                            value: 'country_houses',
                        }
                    ]
                },*/
                currency: {
                    title: 'Валюта',
                    singleSelect: true,
                    list: [
                        {
                            title: 'Рубль',
                            value: 'RUR',
                        },
                        {
                            title: 'Доллар',
                            value: 'USD',
                        },
                        {
                            title: 'Евро',
                            value: 'EUR',
                        },
                    ]
                },
                village: this.$store.state.village,
                complex: this.$store.state.complex,
                tp: this.$store.state.tp
                //},
                /*complex: {
                    title: 'Коттеджный поселок',
                    list: [
                        {
                            title: 'Бакст',
                            value: 'bakst',
                        },
                        {
                            title: 'Лица',
                            value: 'faces',
                        },
                        {
                            title: 'ОКО',
                            value: 'OKO',
                        },
                        {
                            title: 'Тверская д.12',
                            value: 'tverskaya_12',
                        },
                    ]
                },*/
            }
        }
    },
    /*data: () => ({

    }),*/
    methods: {},
    computed: {
        //filters.village: function() {
            /*let obj = this.$store.state.objects.filter(object => object.id === this.$route.params.id);
            return obj[0].location_foto;*/
           /* return {
                title: 'Коттеджный поселок',
                list: [
                    {
                        title: 'Довиль',
                        value: 'deauville',
                    },
                    {
                        title: 'Трувиль',
                        value: 'trouville',
                    },
                ]
            }*/
        //}
        /*village() {
            return {
                title: 'Коттеджный поселок',
                list: [
                    {
                        title: 'Довиль',
                        value: 'deauville',
                    },
                    {
                        title: 'Трувиль',
                        value: 'trouville',
                    },
                ]
            }
        }*/
    },
    created() {
        /*this.village = {
            title: 'Коттеджный поселок',
            list: [
                {
                    title: 'Довиль',
                    value: 'deauville',
                },
                {
                    title: 'Трувиль',
                    value: 'trouville',
                },
            ]
        };*/
    }
}
</script>

<style lang="scss">
.Filters {
  display: inline-block;

  &__trigger {
    display: flex;
    align-items: center;
  }

  &__dropdown {
    padding: 24px 0;
  }

  &__text {
    margin-right: 8px;
    color: $textLightBlack;
  }
}
</style>